export default __webpack_public_path__ + "img/subscripcion.f5ede6be.svg";